/* npm modules outside of vrbo */
import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';

/* Atoms (baseline) */
import {ButtonPrimary} from '../../atoms/baseline/baseline';

/* Molecules (baseline) */
import {BOOKING_CONFIRMATION} from '../../../utils/edapUtils';
import {Unveil} from '../baseline/baseline';

/* Assets */
import addGuestsImage from '../../../images/add-guests.svg';

/* Styles */
import './HasNoGuests.less';
import VrbexContext from '../../context/VrbexContext';

export const HasNoGuests = ({
    actionLocation,
    addGuestUrl,
    addGuestsWidgetButtonLabel,
    guestsDetailsNoGuestsWrapper,
    handleInviteButtonClick,
}) => {
    const {isVrbex} = useContext(VrbexContext);
    let button = (
        <ButtonPrimary
            className={'HasNoGuests__addGuestBtn text-center'}
            label={addGuestsWidgetButtonLabel}
            onClick={handleInviteButtonClick}
        />
    );
    if (isVrbex && actionLocation === BOOKING_CONFIRMATION) {
        button = (
            <ButtonPrimary
                className={'HasNoGuests__addGuestBtn text-center'}
                label={addGuestsWidgetButtonLabel}
                href={addGuestUrl}
            />
        );
    }
    return (
        <Fragment>
            <div className="text-center HasNoGuests__noGuestsWrapper">
                <Unveil
                    className="HasNoGuests__image"
                    backgroundImage={
                        (typeof addGuestsImage === 'function' &&
                            addGuestsImage()) ||
                        ''
                    }
                />
                {guestsDetailsNoGuestsWrapper}
            </div>
            {button}
        </Fragment>
    );
};

HasNoGuests.propTypes = {
    actionLocation: PropTypes.string.isRequired,
    addGuestUrl: PropTypes.string,
    addGuestsWidgetButtonLabel: PropTypes.string.isRequired,
    guestsDetailsNoGuestsWrapper: PropTypes.element.isRequired,
    handleInviteButtonClick: PropTypes.func.isRequired,
};

HasNoGuests.defaultProps = {
    addGuestsWidgetButtonLabel: '',
    handleInviteButtonClick: () => {},
    guestsDetailsNoGuestsWrapper: React.createElement('h3'),
};
